import React, { useState } from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import Layout from "@common/layout/Layout";
import InstructorTable from "./InstructorTable";
import instructorsCubeQuery from "../graphql/instructorsCubeQuery.graphql";
import instructorsFilterQuery from "../graphql/instructorsFilterQuery.graphql";
import useGetQueryVariables from "@dimensions/hooks/useGetQueryVariables";
import { InstructorPage } from "@models/ISchema";

const InstructorSearch: React.FC = () => {
  // Using React Router's useLocation hook to get the query parameters from the URL
  const location = useLocation();
  const params: queryString.ParsedQuery<string> = queryString.parse(location.search);

  // State for managing current page and size per page for pagination
  const [sizePerPage, setSizePerPage] = useState(20);
  const [page, setPageCount] = useState(1);

  // Get the query variables using the custom hook, based on the URL parameters and pagination settings
  const variables = useGetQueryVariables(params, page, undefined, sizePerPage);

  // Choose the appropriate query based on the 'advance' parameter from the URL
  const queryInstructorSearch = params?.advance ? instructorsFilterQuery : instructorsCubeQuery;

  // Fetch data using the Apollo useQuery hook with the chosen query and variables
  const { loading, error, data } = useQuery(queryInstructorSearch, {
    variables,
    fetchPolicy: "network-only",
  });
  let instructors: InstructorPage = data?.cube?.instructors;

  // Assign the fetched data depending on the query used
  if (params?.advance) {
    instructors = data?.filter?.instructors;
  }

  // Render the Layout component and pass the instructors data to the <InstructorTable> component for display
  return (
    <Layout contextSearch>
      <InstructorTable
        onChangeSizePerPage={setSizePerPage} // Function to update the size of items per page
        data={instructors?.items} // Items from instructors data
        search={params?.search?.toString()} // Search query from URL
        pageInfo={instructors?.pageInfo} // Page information for pagination
        setPage={(value: number) => setPageCount(value)} // Function to update the page number
        loading={loading} // Pass loading state from useQuery
        error={error} // Pass error state from useQuery
      />
    </Layout>
  );
};

export default InstructorSearch;
